"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.debug = void 0;
const debugLib = require("debug");
const PLUGIN_NAME = 'snyk-hex-plugin';
exports.debug = debugLib(PLUGIN_NAME);
function init(enable = false) {
    enable ? debugLib.enable(PLUGIN_NAME) : debugLib.disable();
}
exports.init = init;
//# sourceMappingURL=debug.js.map